/**
 * ## Precheck Controller
 *
 * @module src/controllers/precheck
 */

"use strict";

const component = require("../../components/component");
const notification = require("../../components/notification");
const block = require("../../components/block");
const modal = require("../../components/modal");
const print = require("../../components/print");
const func = require("../../controllers/func");
const location = require("../../controllers/location");
const chart = require("../../controllers/chart");
const tabs = require("../../controllers/tabs");
const l = require("../../common").localization;

/** Init
 */
const init = (kd) => {
  const flyoutWaitlist = (target_id, activity_id) => {
    const options = {
      target_id,
      type: "accordion",
      mode: "context_precheck",
      position: "left",
      adjust: {
        x: -5,
        y: 35,
      },
    };

    data.activity = kd.doc("activity", activity_id)[0];

    component.create(options, data, (err, data2) => {
      switch (data2.value) {
        case "seatparty": {
          kd.emit("directseat", { preference: data.activity.preference });
          tabs.tab(kd, "direct", {
            minimal: true,
            size: data2.activity.size,
          });
          chart.setSeatParty(data2.activity, "precheck");
          let msg = l.translate("Please select a table to seat this party.");
          if (!func.isTableAvailable()) {
            msg = l.translate(
              "There may not be a table available to seat this party. " +
                "Please cancel this, clear a table, and try again."
            );
          }
          const opt = {
            position: "top",
            block: "header",
            width: "90%",
            seconds: 0,
            h1: msg,
            body: "",
            buttons: [
              {
                description: l.translate("Cancel"),
                value: "close",
              },
            ],
          };
          notification.create(opt, {}, (err2, value) => {
            kd.emit("directseat", { preference: null });
            notification.destroy();
            chart.clearSeatParty();
            tabs.tab(kd, "precheck");
          });
          /*
                    let proposed = {
                        'domain': 'activity',
                        'status': 3,
                        'time': Date.now(),
                        'size': data.value,
                        'table': data.table,
                        'section': data.section,
                        'name': 'Direct Seating'
                    };
                    kd.update(proposed)
                    .then((result) => {

                    })
                    .catch((err) => {
                        console.log('err', err);
                    });
                    */
          break;
        }
        case "backtoqueue": {
          let status = 1;
          if (
            data2.activity.hasOwnProperty("alerts") &&
            data2.activity.alerts > 0
          ) {
            status = 2;
          }
          const proposed = {
            domain: "activity",
            _id: data2.activity._id,
            status: 1,
          };
          kd.update(proposed)
            .then((result) => {
              const opt = {
                position: "top",
                width: "90%",
                seconds: 2,
                color: "#09e202",
                h1: l.translate("Party has been moved back to the queue"),
                body: "",
                buttons: [
                  {
                    description: l.translate("Close"),
                    value: "close",
                  },
                ],
              };
              notification.create(opt, {}, (err3, value) => {
                notification.destroy();
              });
            })
            .catch((err4) => {
              console.log("err4", err4);
            });
          break;
        }
        case "noshows": {
          const proposed = {
            domain: "activity",
            _id: data2.activity._id,
            status: 6,
          };
          kd.update(proposed)
            .then((result) => {
              const opt = {
                position: "top",
                width: "90%",
                seconds: 2,
                color: "#09e202",
                h1: l.translate("Party has been moved to the No Shows list."),
                body: "",
                buttons: [
                  {
                    description: l.translate("Close"),
                    value: "close",
                  },
                ],
              };
              notification.create(opt, {}, (err5, value) => {
                notification.destroy();
              });
            })
            .catch((err6) => {
              console.log("err6", err6);
            });
          break;
        }
        case "details": {
          opt = {
            width: "90%",
            type: "addparty",
            subtype: "waitlist",
            mode: "waitlist",
            h1: "Dialog Header",
            body: "This is the body text inside the dialog box",
            buttons: [
              {
                description: "cancel",
                value: "cancel...",
              },
              {
                description: "close",
                value: "close",
              },
              {
                description: "third",
                value: "close",
              },
            ],
          };

          const data = {
            kd,
            location: location.location,
            activity: data2.activity,
          };
          modal.create(opt, data, (err9, value) => {
            modal.destroy();
          });
          break;
        }
        case "moveback": {
          const proposed = {
            domain: "activity",
            _id: data2.activity._id,
            status: 8,
          };
          kd.update(proposed)
            .then((resultW) => {
              const proposedW = {
                domain: "reservation",
                _id: data2.activity.res_id,
                status: 1,
              };
              return kd
                .update(proposedW)
                .then((result2) => {
                  const opt = {
                    position: "top",
                    width: "90%",
                    seconds: 2,
                    color: "#09e202",
                    h1: l.translate(
                      "Party has been returned to the reservation list."
                    ),
                    body: "",
                    buttons: [
                      {
                        description: l.translate("Close"),
                        value: "close",
                      },
                    ],
                  };
                  notification.create(opt, {}, (err7, value) => {
                    notification.destroy();
                  });
                })
                .catch((err9) => {
                  console.log("err9", err9);
                });
            })
            .catch((err8) => {
              console.log("err8", err8);
            });
          break;
        }
        case "printchit": {
          modal.destroy();
          setTimeout(() => {
            const opt = {
              type: "waitlist",
              location: location.location,
            };
            print.create(opt, data2.activity);
          }, 10);
          break;
        }
        default:
        // nothing
      }
    });
  };

  // longest

  let opt = {
    kd,
    targetDiv: "content_standard_precheck",
    filter: {
      name: true,
      time: false,
      note: false,
      preference: false,
    },
  };

  const data = {
    type: "precheck",
    domain: "activity",
    h1: l.translate("Pre-Check"),
    h2: "...",
    expand: true,
    single: false,
    group: "all",
    refresh: 30,
    height: {},
    status: {
      min: 7,
      max: 7,
    },
    size: {
      min: 1,
      max: 500,
    },
    waited: {
      min: 0,
      max: 2000,
    },
  };

  block.create(opt, data, (err, target_id, activity_id) => {
    flyoutWaitlist(target_id, activity_id);
  });

  // pre-check wide

  // LEFT OFF HERE: chagne "Seat Party" option in context to Completed or something liek that

  let opt2 = {
    kd,
    targetDiv: "content_wide_precheck",
    filter: {
      name: true,
      time: false,
      note: false,
      preference: false,
    },
  };

  const data2 = {
    type: "precheck",
    domain: "activity",
    h1: l.translate("Pre-Check"),
    h2: "...",
    expand: true,
    single: false,
    group: "all",
    refresh: 30,
    height: {},
    status: {
      min: 7,
      max: 7,
    },
    size: {
      min: 1,
      max: 500,
    },
    waited: {
      min: 0,
      max: 2000,
    },
  };

  block.create(opt2, data2, (err, target_id, activity_id) => {
    flyoutWaitlist(target_id, activity_id);
  });
};

module.exports = {
  init,
};



/** WEBPACK FOOTER **
 ** ./src/controllers/precheck/index.js
 **/